var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"additional-service__list"},_vm._l((_vm.list?.components),function(item){return _c('AdditionalServiceItemComponent',{key:item.id,attrs:{"content":item,"activeUID":_vm.activeUID},on:{"click":_vm._setActiveUID}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }